var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8743 3.64616V3.58637C20.4933 3.15251 19.024 2.91699 17.4993 2.91699C9.44497 2.91699 2.91602 9.44595 2.91602 17.5003C2.91602 17.9925 2.94227 18.4789 2.98966 18.9587H21.8743V3.64616Z",
    fill: "#3F51B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 8.02051H28.5688C27.8709 7.20676 27.0827 6.47686 26.223 5.83301H21.875V8.02051Z",
    fill: "#ECEFF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0096 18.958H21.8749H2.99023C3.06461 19.7076 3.21117 20.4338 3.39492 21.1455H31.6057C31.7887 20.4338 31.9352 19.7076 32.0096 18.958Z",
    fill: "#ECEFF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9056 27.708H7.09375C7.91552 28.5458 8.84229 29.275 9.8449 29.8955H25.1545C26.1571 29.275 27.0839 28.5458 27.9056 27.708Z",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8626 23.333H4.13867C4.47336 24.0986 4.87148 24.83 5.32721 25.5205H29.6741C30.1298 24.83 30.5272 24.0986 30.8626 23.333Z",
    fill: "#ECEFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 12.3955H31.1471C30.862 11.6343 30.5193 10.9029 30.1168 10.208H21.875V12.3955Z",
    fill: "#ECEFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 16.7705H32.0469C32.0097 16.0268 31.9353 15.2932 31.7909 14.583H21.875V16.7705Z",
    fill: "#ECEFF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 5.83301H26.2238C24.9674 4.89238 23.5616 4.14426 22.0376 3.64551H21.875V5.83301Z",
    fill: "#F44336"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 10.208H30.1168C29.6669 9.43072 29.1499 8.69863 28.5695 8.02051H21.875V10.208Z",
    fill: "#F44336"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 14.583H31.7902C31.6371 13.829 31.411 13.1028 31.1464 12.3955H21.875V14.583Z",
    fill: "#F44336"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 18.958H32.0097C32.0571 18.4782 32.0833 17.9919 32.0833 17.4997C32.0833 17.2532 32.0585 17.0133 32.0469 16.7705H21.875V18.958Z",
    fill: "#F44336"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6045 21.1455H3.39453C3.58849 21.8987 3.8313 22.6323 4.13828 23.333H30.8615C31.1678 22.6323 31.4106 21.8987 31.6045 21.1455Z",
    fill: "#F44336"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.673 25.5205H5.32617C5.84461 26.3065 6.43669 27.0386 7.09367 27.708H27.9063C28.5625 27.0386 29.1546 26.3065 29.673 25.5205Z",
    fill: "#F44336"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8457 29.8955C12.0726 31.2736 14.6888 32.083 17.5005 32.083C20.3122 32.083 22.9284 31.2736 25.1553 29.8955H9.8457Z",
    fill: "#F44336"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47461 9.47949L7.81367 10.1999L8.56836 10.3137L8.02148 10.8751L8.15273 11.667L7.47461 11.2937L6.79648 11.667L6.92773 10.8751L6.38086 10.3137L7.13555 10.1999L7.47461 9.47949Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3906 9.47949L10.7297 10.1999L11.4844 10.3137L10.9375 10.8751L11.0688 11.667L10.3906 11.2937L9.7125 11.667L9.84375 10.8751L9.29688 10.3137L10.0516 10.1999L10.3906 9.47949Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55763 11.2934L5.23576 11.6668L5.10451 10.8749L5.65138 10.3134L4.89669 10.1997L4.89378 10.1924C4.65315 10.6065 4.43221 11.0331 4.23242 11.4721L4.55763 11.2934Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3066 9.47949L13.6457 10.1999L14.4004 10.3137L13.8535 10.8751L13.9848 11.667L13.3066 11.2937L12.6285 11.667L12.7598 10.8751L12.2129 10.3137L12.9676 10.1999L13.3066 9.47949Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2246 9.47949L16.5637 10.1999L17.3184 10.3137L16.7715 10.8751L16.9027 11.667L16.2246 11.2937L15.5465 11.667L15.6777 10.8751L15.1309 10.3137L15.8855 10.1999L16.2246 9.47949Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.959 9.47949L19.298 10.1999L20.0527 10.3137L19.5059 10.8751L19.6371 11.667L18.959 11.2937L18.2809 11.667L18.4121 10.8751L17.8652 10.3137L18.6199 10.1999L18.959 9.47949Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47461 15.3125L7.81367 16.0329L8.56836 16.1467L8.02148 16.7081L8.15273 17.5L7.47461 17.1267L6.79648 17.5L6.92773 16.7081L6.38086 16.1467L7.13555 16.0329L7.47461 15.3125Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3906 15.3125L10.7297 16.0329L11.4844 16.1467L10.9375 16.7081L11.0688 17.5L10.3906 17.1267L9.7125 17.5L9.84375 16.7081L9.29688 16.1467L10.0516 16.0329L10.3906 15.3125Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3066 15.3125L13.6457 16.0329L14.4004 16.1467L13.8535 16.7081L13.9848 17.5L13.3066 17.1267L12.6285 17.5L12.7598 16.7081L12.2129 16.1467L12.9676 16.0329L13.3066 15.3125Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55664 15.3125L4.8957 16.0329L5.65039 16.1467L5.10352 16.7081L5.23477 17.5L4.55664 17.1267L3.87852 17.5L4.00977 16.7081L3.46289 16.1467L4.21758 16.0329L4.55664 15.3125Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2246 15.3125L16.5637 16.0329L17.3184 16.1467L16.7715 16.7081L16.9027 17.5L16.2246 17.1267L15.5465 17.5L15.6777 16.7081L15.1309 16.1467L15.8855 16.0329L16.2246 15.3125Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.959 15.3125L19.298 16.0329L20.0527 16.1467L19.5059 16.7081L19.6371 17.5L18.959 17.1267L18.2809 17.5L18.4121 16.7081L17.8652 16.1467L18.6199 16.0329L18.959 15.3125Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 12.3955L8.54219 13.1159L9.29688 13.2297L8.75 13.7911L8.88125 14.583L8.20312 14.2097L7.525 14.583L7.65625 13.7911L7.10938 13.2297L7.86406 13.1159L8.20312 12.3955Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1191 12.3955L11.4582 13.1159L12.2129 13.2297L11.666 13.7911L11.7973 14.583L11.1191 14.2097L10.441 14.583L10.5723 13.7911L10.0254 13.2297L10.7801 13.1159L11.1191 12.3955Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28711 12.3955L5.62617 13.1159L6.38086 13.2297L5.83398 13.7911L5.96523 14.583L5.28711 14.2097L4.60898 14.583L4.74023 13.7911L4.19336 13.2297L4.94805 13.1159L5.28711 12.3955Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0371 12.3955L14.3762 13.1159L15.1309 13.2297L14.584 13.7911L14.7152 14.583L14.0371 14.2097L13.359 14.583L13.4902 13.7911L12.9434 13.2297L13.698 13.1159L14.0371 12.3955Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 12.3955L17.2922 13.1159L18.0469 13.2297L17.5 13.7911L17.6313 14.583L16.9531 14.2097L16.275 14.583L16.4062 13.7911L15.8594 13.2297L16.6141 13.1159L16.9531 12.3955Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 12.3955L20.0266 13.1159L20.7812 13.2297L20.2344 13.7911L20.3656 14.583L19.6875 14.2097L19.0094 14.583L19.1406 13.7911L18.5938 13.2297L19.3484 13.1159L19.6875 12.3955Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 6.5625L8.54219 7.28292L9.29688 7.39667L8.75 7.95812L8.88125 8.75L8.20312 8.37667L7.525 8.75L7.65625 7.95812L7.10938 7.39667L7.86406 7.28292L8.20312 6.5625Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1191 6.5625L11.4582 7.28292L12.2129 7.39667L11.666 7.95812L11.7973 8.75L11.1191 8.37667L10.441 8.75L10.5723 7.95812L10.0254 7.39667L10.7801 7.28292L11.1191 6.5625Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0371 6.5625L14.3762 7.28292L15.1309 7.39667L14.584 7.95812L14.7152 8.75L14.0371 8.37667L13.359 8.75L13.4902 7.95812L12.9434 7.39667L13.698 7.28292L14.0371 6.5625Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 6.5625L17.2922 7.28292L18.0469 7.39667L17.5 7.95812L17.6313 8.75L16.9531 8.37667L16.275 8.75L16.4062 7.95812L15.8594 7.39667L16.6141 7.28292L16.9531 6.5625Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 6.5625L20.0266 7.28292L20.7812 7.39667L20.2344 7.95812L20.3656 8.75L19.6875 8.37667L19.0094 8.75L19.1406 7.95812L18.5938 7.39667L19.3484 7.28292L19.6875 6.5625Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0691 5.83378L10.9379 5.0419L11.4848 4.48044L11.083 4.41992C10.6535 4.63065 10.2372 4.8618 9.83247 5.11263L9.71289 5.83378L10.391 5.46044L11.0691 5.83378Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3066 3.64551L13.6457 4.36592L14.4004 4.47967L13.8535 5.04113L13.9848 5.83301L13.3066 5.45967L12.6285 5.83301L12.7598 5.04113L12.2129 4.47967L12.9676 4.36592L13.3066 3.64551Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2246 3.64551L16.5637 4.36592L17.3184 4.47967L16.7715 5.04113L16.9027 5.83301L16.2246 5.45967L15.5465 5.83301L15.6777 5.04113L15.1309 4.47967L15.8855 4.36592L16.2246 3.64551Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.959 3.64551L19.298 4.36592L20.0527 4.4804L19.5059 5.04186L19.6371 5.83301L18.959 5.45967L18.2809 5.83301L18.4121 5.04113L17.8652 4.47967L18.6199 4.36592L18.959 3.64551Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIcon);
export default __webpack_public_path__ + "static/media/CurrencyIcon.2f9f0bb169fd3ca0a656e1c2f346e2fc.svg";
export { ForwardRef as ReactComponent };